import {
  MAutocomplete,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import dayjs from "dayjs";
import React from "react";
import { useFormContext } from "react-hook-form";

const Refrigeration = () => {
  const form = useFormContext();
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const filterSamplingProcedureList = useFilterSamplingProcedure("REFRI");

  return (
    <ResponsiveFormContainer columns={5} mt={1}>
      <MAutocomplete
        key={JSON.stringify(form.getValues("conditioning_analyst"))}
        name="conditioning_analyst"
        options={userList}
        label="Seleccione un analista"
        getOptionLabel={(option) => option.username || ""}
        validation={{ required: "El analista es requerido" }}
      />
      <MAutocomplete
        key={JSON.stringify(
          form.getValues("conditioning_processing_procedure")
        )}
        name="conditioning_processing_procedure"
        options={filterSamplingProcedureList}
        label="Procedimiento MLPMA"
        getOptionLabel={(option) => `${option.numop}` || ""}
        validation={{
          required:
            filterSamplingProcedureList.length > 0
              ? "El procedimiento MLPMA es requerido"
              : false,
        }}
      />
      <MAutocomplete
        key={JSON.stringify(form.getValues("conditioning_equipment"))}
        name="conditioning_equipment"
        options={equipmentList}
        label="Seleccione un Equipo"
        getOptionLabel={(option) =>
          `${option.codigo} - ${option.descripcion}` || ""
        }
        validation={{ required: "El equipo es requerido" }}
      />
      <MDatePicker
        name="conditioning_date_time"
        pickerType="datetime"
        label="Fecha y hora Inicio"
        validation={{ required: "La fecha y hora de inicio es requerida" }}
        maxDate={dayjs(form.watch("conditioning_date_time_end")) || null}
      />
      <MDatePicker
        name="conditioning_date_time_end"
        pickerType="datetime"
        label="Fecha y hora Fin"
        minDate={dayjs(form.watch("conditioning_date_time")) || null}
      />
    </ResponsiveFormContainer>
  );
};

export default Refrigeration;
